<template>
  <div id="emptyState">
      <v-container fluid>
        <v-row class="pt-12">
          <v-col class="d-flex justify-center" cols="12">
            <v-img
              max-height="302"
              max-width="500"
              src="@/assets/school-illustration.png"
            >
            </v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center" cols="12">
            <p class="headline">Select a school to get started</p>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>
    export default {
        name: "EmptyState"
    }
</script>

<style scoped>

</style>
